import {
  setLeaderBoardData,
  setLBFetchLoading,
} from "../../redux/actions/Quiz";
import appApi from "../../utils/AppApi";
import errorHandler from "../../utils/ErrorHandler";

const LeaderBoardRequests = {
  GetLeaderBoard: (type) => {
    return (dispatch) => {
      dispatch(setLBFetchLoading(true));
      if (type === "allTimes") {
        try {
          appApi.get(`score/scoreboard`).then(({ data }) => {
            dispatch(setLeaderBoardData(data.scoreBoard));
            dispatch(setLBFetchLoading(false));
          });
        } catch (error) {
          errorHandler(error);
          dispatch(setLBFetchLoading(false));
        }
      } else {
        try {
          appApi.get(`score/monthlyScoreBoard`).then(({ data }) => {
            dispatch(setLeaderBoardData(data.monthlyScores));
            dispatch(setLBFetchLoading(false));
          });
        } catch (error) {
          errorHandler(error);
          dispatch(setLBFetchLoading(false));
        }
      }
    };
  },
};

export default LeaderBoardRequests;
